import React, { useState } from "react";
import {
    Paper,
    Grid,
    Typography,
    Button,
    Popover,
    Box,
    IconButton,
    Snackbar,
    SnackbarContent,
} from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings"
import ScoringPopover from "./ScoringPopover";
import { getContrastingColor } from "../../../services/utils";



const QuickScoringMobile = ({ teamA = {}, teamB = {}, teamAInfo, teamBInfo, onAction, openTeamConfig }) => {
    console.log("teamA", teamA);
    console.log("teamB", teamB);


    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);

    const [snack, setSnack] = useState({ open: false, message: "" });

    const notify = (message) => setSnack({ open: true, message });

    const handleClick = (event, team, index) => {
        console.log(team, index);
        setAnchorEl(event.currentTarget);
        setSelectedTeam(team);
        setSelectedIndex(index);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedTeam(null);
        setSelectedIndex(null);
    };

    const handleScore = (action, number, numberOut) => {
        if (onAction && selectedTeam !== null && selectedIndex !== null) {
            onAction(selectedTeam, selectedIndex, action, number, numberOut);
        }
        handleClose();
    };

    const getPlayerData = () => {
        const teamList = selectedTeam === "A" ? teamA : teamB;
        console.log(teamList, selectedIndex, teamList.filter((a) => selectedIndex === a.number))
        return teamList.filter((a) => selectedIndex === a.number)[0] || { name: "team", number: "team" };
    };

    const getPlayerNumber = () => {
        const player = getPlayerData();
        return player.number || selectedIndex + 1;
    };


    const withAlpha = (hex, alpha = 0.15) => {
        // hex tipo #RRGGBB
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    const renderTeam = (teamName, players, teamKey, color) => (
        <Grid item xs={6} >
            <Paper style={{ width: "100%", backgroundColor: color, padding: 10, marginBottom: 10 }}>
                <Grid container justify="center">


                    <Grid item xs={9} >
                        <Button onClick={(e) => handleClick(e, teamKey, "team")}
                            style={{ width: "100%" }}>
                            <Typography variant="h5" noWrap style={{ color: getContrastingColor(color) }}>
                                {teamName}
                            </Typography>

                        </Button>
                    </Grid>
                    <Grid item xs={3} >
                        <IconButton onClick={() => openTeamConfig(teamKey)}
                            style={{ backgroundColor: getContrastingColor(color), color }} >
                            <SettingsIcon />
                        </IconButton>

                    </Grid>

                </Grid>
            </Paper>
            <Grid container spacing={2} justifyContent="space-between">

                {players.sort((a, b) => b.playing - a.playing).map((p, i) => {

                    if (p.number === "team") {
                        return ""
                    }
                    return (

                        p.playing ?
                            <Grid xs={12} item key={i + " " + teamKey}>
                                <Button variant={p.playing ? "contained" : "outlined"}
                                    onClick={(e) => handleClick(e, teamKey, p.number)}
                                    style={{ marginBottom: 5, width: "100%", height: 48, fontSize: 15, borderLeft: `20px solid ${color}`, backgroundColor: withAlpha(color, 0.2) }} >

                                    <Grid container spacing={2} justify="center">
                                        <Grid xs={2} item style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Typography variant="h4" style={{
                                                //backgroundColor: color,
                                                //color: getContrastingColor(color),
                                                //borderRadius: 100,
                                                padding: "4px 10px",
                                                minWidth: 40,
                                                height: "100%",
                                                textAlign: "center",
                                                borderRadius: 0,
                                            }}>
                                                {p.number || "SIN NÚMERO"}
                                            </Typography>
                                        </Grid>
                                        <Grid xs={9} item style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Typography variant="subtitle1">
                                                {p.name}
                                            </Typography>
                                        </Grid>
                                        <Grid xs={1} item style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Typography variant="body2" style={{ padding: "6px 10px", fontSize: 11, borderRadius: 5, backgroundColor: p.totalFaltas >= 5 ? "red" : "", color: p.totalFaltas >= 5 ? "#ffffff" : "" }}>
                                                P:{p.totalPuntos} F:{p.totalFaltas}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Button>
                            </Grid> :
                            <Grid xs={6} item key={i}>
                                <Button variant={p.playing ? "contained" : "outlined"}
                                    onClick={(e) => handleClick(e, teamKey, p.number)}
                                    style={{ width: "100%", height: 48, fontSize: 25, borderLeft: `20px solid ${color}`, backgroundColor: withAlpha(color, 0.2) }} >

                                    <Typography variant="h4" style={{
                                        //backgroundColor: color,
                                        color: "#000000",//getContrastingColor(color),
                                        borderRadius: 100,
                                        padding: "4px 10px",
                                        minWidth: 48,
                                        textAlign: "center"
                                    }}>

                                        {p.number || "SIN NÚMERO"}
                                    </Typography>

                                </Button>
                            </Grid>
                    )
                })}
            </Grid >


        </Grid >
    );



    return (
        <Paper style={{ padding: 10 }}>
            <Grid container spacing={3} justifyContent="space-between">
                {renderTeam(teamAInfo.name, teamA, "A", teamAInfo.teamColor || "#5c5c5c")}
                {renderTeam(teamBInfo.name, teamB, "B", teamBInfo.teamColor || "#000000")}
            </Grid>

            <ScoringPopover
                anchorEl={anchorEl}
                onClose={handleClose}
                onScore={handleScore}
                playerData={getPlayerData()}
                playerNumber={getPlayerNumber()}
                players={{ A: teamA, B: teamB }}
                onNotify={notify}
            />
            <Snackbar
                open={snack.open}
                message={snack.message}
                autoHideDuration={3000}
                onClose={() => setSnack(s => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}

            >
                <SnackbarContent
                    message={snack.message}
                    style={{
                        fontSize: 22,          // 👈 tamaño de fuente
                        fontWeight: 600,
                        textAlign: "center",
                    }}
                />
            </Snackbar>
        </Paper>
    );
};

export default QuickScoringMobile;
